import React from 'react'
import { PolicyTypes, useUserData } from '../../context/UserDataContext';
import { Navigate } from 'react-router-dom';

interface PolicyRouteProps {
    requiredPolicy: PolicyTypes;
    children: React.ReactNode;
}

const PolicyRoute = (props: PolicyRouteProps) => {

    const { hasPolicy, loading } = useUserData();
    
    if (loading) 
    {
        return <div>Loading...</div>;
    }

    if (!hasPolicy(props.requiredPolicy)) 
    {
        // Redirect to unauthorized page
        return <Navigate to="/unauthorized" replace />;
    }

    return <>{props.children}</>;
}

export default PolicyRoute